import { Heading1, Heading2, Heading3, Heading4 } from './Heading';

export { Heading1, Heading2, Heading3, Heading4 };
